export default __webpack_public_path__ + "static/media/confetti.d1f8829d.svg";